import { render } from "./ListarSaidasAnimais.vue?vue&type=template&id=7a928547&scoped=true"
import script from "./ListarSaidasAnimais.vue?vue&type=script&lang=js"
export * from "./ListarSaidasAnimais.vue?vue&type=script&lang=js"

import "./ListarSaidasAnimais.vue?vue&type=style&index=0&id=7a928547&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a928547"]])

export default __exports__